/** Office file formats QCBot can review. A QC template opts in to one or both (see QcTemplate.documentTypes). */
export const DOCUMENT_TYPES = ['pptx', 'docx'];
/** The independently retryable steps of a review run, in execution order. */
export const REVIEW_PASSES = ['deterministic', 'judgment', 'imageComparison', 'aiSuggestion', 'fixProposal'];
//# sourceMappingURL=types.js.map